import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'fi-side-list-item-header',
    template: '<ng-content></ng-content>',
    styleUrls: ['./side-list-item-header.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-side-list-item-header' },
    standalone: false,
})
export class SideListItemHeaderComponent {}
